import { useEffect, useRef, useState } from 'react'
import Markdown from './Markdown'

const PARSE_EVERY_MS = 60

/** Re-parsing the whole reply on every revealed character would burn the frame budget,
 * so the markdown lags the typed text slightly while a turn streams. */
export default function StreamingMarkdown({ text }: { text: string }) {
  const [shown, setShown] = useState(text)
  const parsedAt = useRef(0)

  useEffect(() => {
    const wait = Math.max(0, PARSE_EVERY_MS - (Date.now() - parsedAt.current))
    const handle = setTimeout(() => {
      parsedAt.current = Date.now()
      setShown(text)
    }, wait)
    return () => clearTimeout(handle)
  }, [text])

  return <Markdown text={shown} variant="bubble" />
}
